export class ParticipantAlreadyInSessionError extends Error {
  constructor(
    public deviceName: string,
    public userDisplayName: string,
    public sabhaDeviceId: string,
    public sabhaParticipantId: string
  ) {
    super('Already in session ' + deviceName + ', ' + userDisplayName);
  }
}

export interface DeviceMissingError extends Error {
  deviceId: string;
  details: string;
}

export class UnsupportedDeviceError extends Error {}

export const isParticipantAlreadyInSessionError = (err: unknown): err is ParticipantAlreadyInSessionError =>
  err instanceof ParticipantAlreadyInSessionError;

export const isUnsupportedDeviceError = (err: unknown): err is UnsupportedDeviceError =>
  err instanceof UnsupportedDeviceError;

export const isDeviceMissingError = (err: any): err is DeviceMissingError =>
  err?.deviceId && err?.details;
